import { AvailableTimeSlot } from "../sessions/time-slot/models/AvailableTimeSlot";

/**
 * Groups time slots by date
 * @param timeSlots Array of available time slots
 * @returns Object with dates as keys and time slots as values
 */
export const groupTimeSlotsByDate = (
  timeSlots: AvailableTimeSlot[]
): Record<string, AvailableTimeSlot[]> => {
  return timeSlots.reduce((groups, slot) => {
    const dateKey = slot.dateStart.split("T")[0]; // Get YYYY-MM-DD format
    if (!groups[dateKey]) {
      groups[dateKey] = [];
    }
    groups[dateKey].push(slot);
    return groups;
  }, {} as Record<string, AvailableTimeSlot[]>);
};

/**
 * Sorts time slots by time
 * @param timeSlots Array of time slots to sort
 * @returns Sorted array of time slots
 */
export const sortTimeSlotsByTime = (
  timeSlots: AvailableTimeSlot[]
): AvailableTimeSlot[] => {
  return [...timeSlots].sort((a, b) => {
    // Convert UTC dates to local time for comparison
    const dateA = new Date(a.dateStart);
    const dateB = new Date(b.dateStart);
    return dateA.getTime() - dateB.getTime();
  });
};

/**
 * Filters time slots to show only upcoming slots (not past times for today)
 * Properly handles UTC dates from backend with local time display
 * @param timeSlots Array of time slots to filter
 * @returns Filtered array of time slots
 */
export const filterUpcomingTimeSlots = (
  timeSlots: AvailableTimeSlot[]
): AvailableTimeSlot[] => {
  const now = new Date();

  return timeSlots.filter((slot) => {
    const slotLocalDateTime = new Date(slot.dateStart);

    const isUpcoming = slotLocalDateTime > now;

    return isUpcoming;
  });
};

/**
 * Generates a date range from current date to current date + days
 * @param days Number of days to add to current date
 * @returns Object with startDate and endDate
 */
export const generateDateRangeFromCurrentDate = (days: number) => {
  const startDate = new Date();
  startDate.setHours(0, 0, 0, 0); // Start of today

  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + days);
  endDate.setHours(23, 59, 59, 999); // End of the target day

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};
